import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { history, fetchWrapper } from '_helpers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// create slice

const name = 'file';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState,  extraReducers });

// exports

export const fileActions = { ...slice.actions, ...extraActions };
export const fileReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        error: null
    }
}


function createExtraActions() {
    const baseUrl = `https://api.webtracktechnologies.com.au:8002`;
   //const registerUrl = `${process.env.REACT_APP_API_URL}/frontend/auth/register/step-1`;

    return {
        getAudioFiles : getAudioFiles(),
        searchAudioFile: searchAudioFile(),
        getAudioFileByType:getAudioFileByType(),
        getStudyResults:getStudyResults(),
    };    

    function getAudioFiles() {
        return createAsyncThunk(
            `${name}/file`,
            async () => await fetchWrapper.get(`${baseUrl}/file/all-audios`)
        );
    }

    function searchAudioFile() {
        return createAsyncThunk(
            `${name}/file`,
            async ({start_date,end_date,studentId,studentName,className}) => await fetchWrapper.post(`${baseUrl}/file/audio-search`,{start_date,end_date,studentId,studentName,className})
        );
    }

    function getAudioFileByType() {
        return createAsyncThunk(
            `${name}/file`,
            async ({teacher_id,type,date,classId}) => await fetchWrapper.get(`${baseUrl}/file/teacher_records/`+teacher_id+'?type='+type+'&date='+date+'&classId='+classId)
        );
    }

    function getStudyResults() {
        return createAsyncThunk(
            `${name}/file`,
            async () => await fetchWrapper.get(`${baseUrl}/file/searchrecords`)
        );
    }

}

function createExtraReducers() {
    return {
        ...getAudioFiles(),
        ...searchAudioFile(),
        ...getAudioFileByType(),
        ...getStudyResults(),
    };

    function getAudioFiles() {
        var { pending, fulfilled, rejected } = extraActions.getAudioFiles;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const file = action.payload;
              //console.log(user,'get register user');  return false;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('user', JSON.stringify(user));
                state.files = file;
                // toast.success('Check your email to verify the account..', {
                //     position: "top-right",
                //     autoClose: 5000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                //     theme: "light",
                //     });
                // get return url from location state or default to home page
                // const { from } = { from: { pathname: '/verify-email' } };
                // history.navigate(from);
            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function searchAudioFile() {
        var { pending, fulfilled, rejected } = extraActions.searchAudioFile;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const file = action.payload;

                state.files = file;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function getAudioFileByType() {
        var { pending, fulfilled, rejected } = extraActions.getAudioFileByType;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const file = action.payload;
                state.files = file;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function getStudyResults() {
        var { pending, fulfilled, rejected } = extraActions.getStudyResults;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const file = action.payload;
                state.files = file;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

}
